import {MedicationProfileFormFields} from '@/modules/drug-catalog/medication-profiles/components/medication-profile-form/medication-profile-form-fields'
import {MedicationProfileFormDialogOptions} from '@/modules/drug-catalog/medication-profiles/constants'
import {DialogBody} from '@cypro/ui/components'
import {withForm} from '@cypro/ui/integrations/form'

export const MedicationProfileFormDialog = withForm({
  ...MedicationProfileFormDialogOptions,
  render: function Render({form, onSubmit, ...handlers}) {
    return (
      <DialogBody padding="0" overflow="hidden">
        <form onSubmit={onSubmit} style={{height: '100%', display: 'flex', flexDirection: 'column', overflow: 'auto'}}>
          <form.AppForm>
            <MedicationProfileFormFields form={form} {...handlers} />
          </form.AppForm>
        </form>
      </DialogBody>
    )
  },
})
